import * as React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FaSpinner from 'react-icons/fa/spinner';
import SaveQuoteModal from '../../components/SaveQuoteModal';

interface INavigationBarProps {
  submitting?: boolean;
  submitFailed?: boolean;
  valid?: boolean;
  hasBackButton?: boolean;
  hasNextButton?: boolean;
  nextButtonText?: string;
  backTo?: string;
  isInPaymentPage?: boolean;
  onClickSubmit?: any;
  saveQuoteModal ?: any;
  nextButtonDisabled?: boolean;
  hasSaveButton?: boolean;
  calculateOnSave?: boolean;
}

class NavigationBar extends React.Component<INavigationBarProps> {
  public static defaultProps: Partial<INavigationBarProps> = {
    hasNextButton: true,
    saveQuoteModal: '',
    nextButtonText: 'Continue',
    nextButtonDisabled: false,
  };

  public render() {
    const {
      submitting,
      submitFailed,
      valid,
      hasBackButton,
      backTo,
      isInPaymentPage,
      onClickSubmit,
      hasNextButton,
      saveQuoteModal,
      nextButtonText,
      nextButtonDisabled,
      hasSaveButton,
    } = this.props;
    return (
      <div className="btn-bar ">
        <Row>
          <Col sm={12} md={6} lg={4}>
            {hasBackButton && (
              <Link
                className="btn-secondary back-btn btn notification-btn-size"
                to={backTo}
              >
                <><img src={require('../../img/arrow-alt-left.svg')} className="button-logo" />{' '}Back</>
              </Link>
            )}
          </Col>
          <Col sm={12} md={3} lg={6}>
            {hasSaveButton && (
              <div className="sidebar-layout">
                <SaveQuoteModal {...this.props}/>
              </div>
            )}
          </Col>
          <Col sm={12} md={3} lg={2}>
            {hasNextButton && (
              <Button
                type={isInPaymentPage ? 'button' : onClickSubmit ? 'button' : 'submit'}
                className="continue-btn btn-primary notification-btn-size"
                onClick={onClickSubmit}
                disabled={submitting || (submitFailed && !valid) || nextButtonDisabled}
              >
                {submitting ? (
                  <FaSpinner className="fa-spin spin-icon"/>
                ) : (
                  isInPaymentPage ? 'Purchase' : <>{nextButtonText}
                  {' '}<img src={require('../../img/arrow-alt-right.svg')} className="button-logo" /></>
                )}
              </Button>
            )}
            {saveQuoteModal}
          </Col>
        </Row>
      </div>
    );
  }
}

export default NavigationBar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/NavigationBar/index.tsx